import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Brands from "@/pages/Brands";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Build from "@/pages/Build";
import Booking from "@/pages/Booking";
import Motorcycles from "@/pages/Motorcycles";
import Estimate from "@/pages/Estimate";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/services" element={<Services />} />
              <Route path="/build" element={<Build />} />
              <Route path="/book" element={<Booking />} />
              <Route path="/motorcycles" element={<Motorcycles />} />
              <Route path="/estimate" element={<Estimate />} />
              <Route path="/about" element={<About />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
